import type { DrillAnswer, DrillAnswerBody, DrillSpec } from "./Drill";
import { TIME_STEP_S } from "./TIME_STEP_S";

// Черновик ответа до «Проверить». У ползунка сразу есть значение — середина шкалы,
// поэтому ответить можно и не двигая его.
export const draftAnswer = (spec: DrillSpec): DrillAnswer => {
  if (spec.mechanic !== "time") {
    return { option_ids: [], value: null, pairs: [] };
  }
  const middle = ((spec.min_value ?? 0) + (spec.max_value ?? 0)) / 2;
  return { option_ids: [], value: Math.round(middle / TIME_STEP_S) * TIME_STEP_S, pairs: [] };
};

// Ответ из попытки (поля по умолчанию сервер может не прислать) — в полном виде.
export const fullAnswer = (answer: DrillAnswerBody): DrillAnswer => ({
  option_ids: answer.option_ids ?? [],
  value: answer.value ?? null,
  pairs: answer.pairs ?? [],
});

// Можно ли отправлять: выбран вариант, расставлены все, соединены все пары.
export const isAnswerReady = (spec: DrillSpec, answer: DrillAnswer): boolean => {
  switch (spec.mechanic) {
    case "choice":
    case "timeline":
    case "multi":
      return answer.option_ids.length > 0;
    case "order":
      return answer.option_ids.length === spec.options.length;
    case "pairs":
      return answer.pairs.length === spec.pairs.length;
    case "time":
      return answer.value !== null;
  }
};
